import React from "react";
import * as styles from "./InlineCTABox.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export interface InlineCTABoxProps {
  className?: string;
  align?: "center" | "right" | "left";
}

export const InlineCTABoxButton: React.FC = (props) => {
  return <React.Fragment>{props.children}</React.Fragment>;
};

export const InlineCTABoxContent: React.FC = (props) => {
  return <div className={styles.content}>{props.children}</div>;
};

const InlineCTABox: React.FC<InlineCTABoxProps> = ({
  className = undefined,
  align = "center",
  children
}) => {
  return (
    <div
      className={cx({
        inlineCtaBox: true,
        [className || ""]: className,
        alignLeft: align == "left",
        alignCenter: align == "center",
        alignRight: align == "right"
      })}
    >
      {children}
    </div>
  );
};

export default InlineCTABox;
